import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const keyContext = createContext();

function KeyContextProvider(props) {
 
  const key = sessionStorage.getItem("key");
  let orgId = sessionStorage.getItem("orgID");
  const [all_events_edit, setAll_events_edit] = useState();
  const [data, setData] = useState([]);
  const [dagsData, setDagsData] = useState([]);
  const [dagensData, setDagensData] = useState([]);
  const [open, setOpen] = useState(false);
  const [dagensSelectedDate, setDagensSelectedDate] = useState("");
  const [dagensNextDay, setDagensNextDay] = useState("");
  const [dagsFilm, setDagsFilm] = useState("");
  const [defaultFilm, setDefaultFilm] = useState("");
  const [filmId, setFilmId] = useState("");
  const [networkError, setNetworkError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isChecked, setIsChecked] = useState(localStorage.getItem("burgerMenuChecked") === "true" ? true : false );
  const [selectAllFilmAtOnce, setSelectAllFilmAtOnce] = useState(false)
  const [clickedMovieDiv, setClickedMovieDiv] = useState();
  const [moviesSelected, setMoviesSelected ] = useState(false)
  const [isSoldChecked, setIsSoldChecked] = useState(true);
  const [anyMovieSelected, setAnyMovieSelected ] = useState(false)
  const [distributorsName, setDistributorsName] = useState('');
  const [pushModal, setPushModal] = useState(false);
  const [programmedDates,setProgrammedDates] = useState([])
  const [eventsChanged, setEventsChanged] = useState(false);
  const [isTicketChecked, setIsTicketChecked] = useState( true );
  const [isKioskChecked, setIsKioskChecked] = useState(true );
  const [isAndenChecked, setIsAndenChecked] = useState(true );
  const [isSamletChecked, setIsSamletChecked] = useState(true);
  const [isKioskOmsChecked, setIsKioskOmsChecked] = useState(true );
  const [filmBioChanged, setFilmbiochanged] = useState(false);
  const [chosenCinema, setChosenCinema] = useState(false);
  const [orgSelect, setOrgSelect] = useState( sessionStorage.getItem('programOrg') ?  sessionStorage.getItem('programOrg') : '' );
  const [movieNumber, setMovieNumber] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedStartDate, setSelectedStartDate] = useState(sessionStorage.getItem('program_start_date') ? new Date(sessionStorage.getItem('program_start_date')) :  new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(sessionStorage.getItem('program_end_date') ? new Date(sessionStorage.getItem('program_end_date')) :  new Date());
  const [weekBoxOpen, setWeekBoxOpen] = useState(false)
  const [containerHeight, setContainerHeight] = useState('')
  const [leftSpace,setLeftSpace] = useState('')
  const [leftMargin, setLeftMargin] = useState('')
  const [calendarShow, setCalendarShow] = useState(false)
  const [arrTypes, setArrTypes] = useState([])
  const [allTicketTypes, setAllTicketTypes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false)
  const [deletebtnclk, setDeletebtnclk] = useState(false)
  const [dateChosen, setDateChosen] = useState(false)
  const [webEditing, setWebEditing] = useState(false);
  const [editedEvId, setEditedEvId] = useState();
  const [divOpened, setDivOpened]   = useState(false);
  const [savebtnclk, setSavebtnclk] = useState(false);
  const [alertEvents, setalertEvents] = useState();
  const [allzero, setAllzero] = useState(false);
  const [allOne, setAllOne] = useState(false);
  const [eventEdit, seteventEdit] = useState(false);
  const [eventSaveObj, setEventSaveObj] = useState()
  const [titleChanged, setTitleChanged] = useState(false);
  const [showGrunddataModal, setShowGrunddataModal] = useState(false);
  const [selectedFilmId, setSelectedFilmId] = useState(0);
  const [titleNotSaved, setTitleNotSaved] = useState(false);
  const [visualDivHeight, setVisualDivHeight] = useState();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorNo, setErrorNo] = useState();
  const [errorText, setErrorText] = useState('');
  const [clkdMovieName, setClkdMovieName] = useState('')
  const [programRights, setProgramRights] = useState([])
  const [showFilm, setShowFilm]   = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [waitingModal, setWaitingModal] = useState(false);
  const [apiLoader, setApiLoader] = useState(false);
  const [errorStatus, setErrorStatus] = useState();
  const [errorType, setErrorType] = useState();
  const [changesLeft, setChangesLeft] = useState();
  const [changes, setChanges] = useState();
  const [eventErrorModal, setEventErrorModal] = useState(false);
  const [manEventErrortext, setManEventErrortext] = useState();
  const [draggedMovieId,setDraggedMovieId]  = useState()
  const [draggedFilm, setDraggedFilm] = useState('')
  const [showG,setShowG] = useState(false)
  const [call_get_program, setCall_get_program] = useState();
  const [selectedMovieEvent, setSelectedMovieEvent] = useState();
  const [refno0, setRefno0] = useState(false);
  const [openSideDiv, setOpenSideDiv] = useState(false);
  const [editDiv, setEditDiv] = useState(false);
  const [contentEdit, setContentEdit] = useState(false);
  // const [orgID, setOrgID] = useState(sessionStorage.getItem('news_org')? sessionStorage.getItem('news_org'): '');

  const [newsletterOrg, setNewsletterOrg] = useState();
  // const [deletedNewsletterNo, setDeletedNewsletterNo] = useState()

  
 // program configurtations below
  const [zeroPriceAlert, setZeroPriceAlert] = useState(localStorage.getItem('zeroPriceAlert') === "true" ? true : false);
  const [ticketTypeAlert, setTicketTypeAlert] = useState(localStorage.getItem('ticketTypeAlert') === 'true' ? true : false);

  const [adValue, setAdValue] = useState(localStorage.getItem('adTrailerTime') ? localStorage.getItem('adTrailerTime'): 0);
  const [cleanValue, setCleanValue] = useState(localStorage.getItem('cleaningTime') ? localStorage.getItem('cleaningTime') :0);
  const [defaultStart, setDefaultStart] = useState(localStorage.getItem('defaultTimeStart')? localStorage.getItem('defaultTimeStart'): '11:00');
  const [defaultEnd, setDefaultEnd] = useState(localStorage.getItem('defaultTimeEnd') ? localStorage.getItem('defaultTimeEnd') :'20:00');
  const [sameTimeLine, setSameTimeLine] = useState(localStorage.getItem('sameTimeline') === 'true' ? true : false);
  let flag = false 
  let default_filmID = sessionStorage.getItem('default-filmID')
  let ge = sessionStorage.getItem('programOrg')

  let org = ge && ge.split(" ")[ge.split(" ").length - 1]



  // man_event_push_check call
 function eventPushCheck () {  
       setWaitingModal(true)
       setPushModal(true)
      
   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_push_check` ,{
        method: "POST",     
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',     
       },
       body:`Key=${key}&orgNo=${default_filmID ? default_filmID : org}`
   })
    .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setPushModal(false)
          setWaitingModal(false)
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => {
         if(result.Result === 0) {
          logOut()
          
         }
         setWaitingModal(false)
         setApiLoader(false)
         setChanges(result.ChangesLeft)
         setChangesLeft(result.ChangesLeft)
      if(result.ChangesLeft === 0) {
        //  setCommitModal(false)
        window.location.reload()
      }
      })
       
        
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)
               console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
}
  
  function logOut() {
   
    sessionStorage.removeItem("key");
    sessionStorage.removeItem("period");
    sessionStorage.removeItem("film");
    sessionStorage.removeItem("default-filmID");
    sessionStorage.removeItem("orgID");
    sessionStorage.setItem('programRight',false)
    sessionStorage.removeItem('programOrg')
    sessionStorage.removeItem('filmRight')
    sessionStorage.removeItem('user')
    sessionStorage.removeItem('password')
    sessionStorage.removeItem('program_date')
    sessionStorage.removeItem('newsletter_bio')
   // sessionStorage.removeItem('selected-date')

    setData("");
    setDagsData("");
    setDagensData("");
    
    window.location.reload();
  }

  
  return (

    <keyContext.Provider
      value={{
        //  orgID, setOrgID,
        //  deletedNewsletterNo, setDeletedNewsletterNo,
        // newsletterDelete, setNewsletterDelete,
        // newsletterModal, setNewsletterModal,
        newsletterOrg, setNewsletterOrg,
        contentEdit, setContentEdit,
        editDiv, setEditDiv,
        openSideDiv, setOpenSideDiv,
        refno0, setRefno0,
        sameTimeLine, setSameTimeLine,
        selectedMovieEvent, setSelectedMovieEvent,
        call_get_program, setCall_get_program,
        showG,setShowG,
        draggedFilm, setDraggedFilm,
        draggedMovieId,setDraggedMovieId,
        defaultEnd, setDefaultEnd,
        defaultStart, setDefaultStart,
        cleanValue, setCleanValue,
        adValue, setAdValue,
      
        ticketTypeAlert, setTicketTypeAlert,
        zeroPriceAlert, setZeroPriceAlert,
        manEventErrortext, setManEventErrortext,
        all_events_edit, setAll_events_edit,
        eventErrorModal, setEventErrorModal,
        programmedDates,setProgrammedDates,
        logOut, changes,changesLeft, setChangesLeft,eventPushCheck,
        isKioskChecked, setIsKioskChecked,
        isKioskOmsChecked, setIsKioskOmsChecked,
        isSamletChecked, setIsSamletChecked,
        isAndenChecked, setIsAndenChecked,
        isTicketChecked, setIsTicketChecked,
        isSoldChecked, setIsSoldChecked,
        isChecked,   setIsChecked,
        dagensNextDay,  setDagensNextDay,
        dagensSelectedDate,   setDagensSelectedDate,
        open,    setOpen,
        dagensData,   setDagensData,
        defaultFilm,    setDefaultFilm,
        networkError,
        dagsFilm,    setDagsFilm,
        dagsData,      setDagsData,
        data,      setData,
        userName,    setUserName,
        password,      setPassword,
        movieNumber,      setMovieNumber,
        startDate,      setStartDate,
        endDate,       setEndDate,
        filmId,      setFilmId,
        errorMessage,
        selectAllFilmAtOnce,  setSelectAllFilmAtOnce,
      selectedStartDate, setSelectedStartDate,
      selectedEndDate, setSelectedEndDate,
        weekBoxOpen, setWeekBoxOpen,
        containerHeight, setContainerHeight,
        leftSpace,setLeftSpace,
        chosenCinema, setChosenCinema,
        leftMargin, setLeftMargin,
        orgSelect, setOrgSelect,
        calendarShow, setCalendarShow,
        arrTypes, setArrTypes,
        allTicketTypes, setAllTicketTypes,
        modalOpen, setModalOpen,
        moviesSelected, setMoviesSelected,
        deletebtnclk, setDeletebtnclk,
        dateChosen, setDateChosen,
        anyMovieSelected, setAnyMovieSelected ,
        webEditing, setWebEditing,
        editedEvId, setEditedEvId,
        divOpened, setDivOpened,
        savebtnclk, setSavebtnclk,
        allzero, setAllzero,
        allOne, setAllOne,
        alertEvents, setalertEvents,
        eventEdit,seteventEdit,
        eventsChanged,setEventsChanged,
        eventSaveObj, setEventSaveObj,
        titleChanged, setTitleChanged,
        showGrunddataModal, setShowGrunddataModal,
        selectedFilmId, setSelectedFilmId,
        titleNotSaved, setTitleNotSaved,
        visualDivHeight, setVisualDivHeight,
        showErrorModal, setShowErrorModal,
        errorNo, setErrorNo,
        errorText, setErrorText,
        distributorsName, setDistributorsName,
        filmBioChanged, setFilmbiochanged,
        clkdMovieName, setClkdMovieName,
        programRights, setProgramRights,
        showFilm, setShowFilm,
        showDropdown, setShowDropdown,
        clickedMovieDiv, setClickedMovieDiv,
        waitingModal, setWaitingModal,
        apiLoader, setApiLoader,
        errorStatus, setErrorStatus,
        errorType, setErrorType,
        pushModal, setPushModal
      }}
    >
      {props.children}
    </keyContext.Provider>
  );
}

export default KeyContextProvider;
